import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";

import Dialog from "componentsv2/modal/Dialog";
import ModalForm from "componentsv2/modal/ModalForm";
import CardsHeader from "componentsv2/card/CardsHeader";
import GridCards from "componentsv2/card/GridCardsNew";
import EmptyData from "componentsv2/widgets/EmptyData";
import { genStoreId } from "componentsv2/tools/functions";
import { useTable } from "storev2/tableStore";
import { useStore, insertRecord } from "storev2/formStore";
import { cn } from "tools/ui";

/**
 * @param {Array } layout
 * @param {Array} domain
 * @param {Function} onChangeView
 * @param {Array} parent
 * @return
 */
function BoardCards({
  layout,
  parentRec,
  parentStoreId,
  CustomForm,
  reloadId,
  style,
  args,
  reload,
}) {
  const openModal = useSignal(false);
  const recordStoreId = useSignal(null);

  const { model, card } = layout;
  const styleHeader = parentRec ? "small" : "big";

  const storeId = genStoreId(model, null, parentStoreId);
  const { presetTable } = useTable();
  const table = useTable((state) => state[storeId]);

  async function closeModal(mustReload) {
    openModal.value = false;
    if (mustReload) {
      await reload();
    }
  }

  async function handleView(action, recordId) {
    // console.log("handle view....", action, recordId);
    const { newRecord } = useStore.getState();
    if (action === "open") {
      recordStoreId.value = await insertRecord(recordId, model, layout);
      // storeId.value = recordId;
    } else {
      recordStoreId.value = await newRecord(layout, parentRec);
      // currentRecordId.value = newRecordId;
    }
    openModal.value = true;
  }

  useEffect(() => {
    // console.log("reloadId desde Boards Cards...", reloadId);
    presetTable(storeId, layout, parentRec);
  }, [parentRec?.record?.id, reloadId]);

  return (
    <div id="board-cards" className={cn("mt-4 mb-6", style)}>
      <CardsHeader
        layout={layout}
        handleView={handleView}
        storeId={storeId}
        count={0}
        kind={styleHeader}
        // count={_records?.length || 0}
      />
      {table?.records.length > 0 ? (
        <GridCards
          storeId={storeId}
          layout={layout}
          records={table?.records || []}
          Card={card}
          handleView={handleView}
        />
      ) : (
        <EmptyData style="mt-4" />
      )}
      <div className="board-cards-modal">
        {openModal.value &&
          recordStoreId.value &&
          (CustomForm ? (
            <Dialog
              id="card-modal-custom"
              size={size || "h-4/5 w-full md:w-1/3"}
              openModal={openModal}
              handleClose={closeModal}
              buttons={[{ name: "close", onClick: closeModal }]}
              title={model}
            >
              <CustomForm
                // FIXME, use storeId
                recordId={recordStoreId.value}
                layout={layout}
                parentRec={parentRec}
              />
            </Dialog>
          ) : (
            <ModalForm
              storeId={recordStoreId.value}
              layout={layout}
              parentRec={parentRec}
              onClose={closeModal}
              size="w-full md:2/3 lg:w-3/4 max-h-[90vh]"
              openModal={openModal}
            />
          ))}
      </div>
    </div>
  );
}

export default BoardCards;
